<template>
  <modal-layout :options="options">
    <styledLanguageSelect class="modal__options">
      <li
        v-for="option in modalOptions"
        :key="option.l"
        @click="selectLanguage($event, option.l)"
        :class="{ disabled: $i18n.locale === option.l }"
      >
        {{ $t(option.t) }}
      </li>
    </styledLanguageSelect>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/layouts/Modal';
import styled from 'vue-styled-components';

const styledLanguageSelect = styled('ul', {})`
  li.disabled {
    color: var(--on_primary);
    background-color: var(--primary) !important;
    opacity: 0.5;
    pointer-events: none;
  }
`;
export default {
  components: { ModalLayout, styledLanguageSelect },
  data() {
    return {
      modalOptions: [
        { l: 'en', t: 'in_english' },
        { l: 'ru', t: 'in_russian' },
        { l: 'uk', t: 'in_ukrainian' },
      ],
      options: {
        title: 'select-language',
        callbackType: 'LangDialog',
      },
    };
  },

  methods: {
    selectLanguage(e, locale) {
      e.stopPropagation();
      this.$bus.$emit('changeLocale', locale);
      this.$bus.$emit(`LangDialogToggle`, false);
    },
  },
};
</script>
